/* tslint:disable */
// NOTE: For some reason jquery and jquery-ui must be specified in scripts in angular.json in order to work
// https://medium.com/@swarnakishore/how-to-include-and-use-jquery-in-angular-cli-project-592e0fe63176
// ui-bootstrap, angular-ui-bootstrap, bootstrap-datepicker and intl-tel-input all depend on jquery.
// And JQueryLight does not implement hide/show on elements
// JQueryLight also does not implement element.find() used by one-number.directive.js, but it's just for debug logging so can be removed

// angularJS core must be loaded before Angular modules (but other modules can be imported here)
// https://medium.com/code-divoire/a-story-of-ngupgrade-bringing-an-angularjs-application-from-1-6-to-angular-4-84eae4434010

import 'angular-route';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-animate';
import 'angular-mocks';
import 'angular-translate';

import * as CodeMirror from 'codemirror';
// Make CodeMirror available globally so the modes' can register themselves.
(window as any).CodeMirror = CodeMirror;
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'angular-ui-codemirror';
import '../../src/main/webapp/app/common/codemirror-mangle.directive.js';
import 'codemirror/addon/display/panel';
import 'codemirror/addon/search/searchcursor';
import 'codemirror-advanceddialog/dist/advanced-dialog.js';
import 'codemirror-revisedsearch/dist/revised-search';

// import 'moment';

import * as momentTimezone from 'moment-timezone';
// import 'moment-timezone';
// To use moment-timezone we need to override moment with the function from moment-timezone
// This way it should not be necessary to override in autoremind.app.js
(window as any).moment = momentTimezone;
//(window as any).momentTimezone = momentTimezone;
import 'angular-moment';

import * as X2JS from 'x2js';
(window as any).X2JS = X2JS;

import 'json-js/cycle'; // This is used by userProfile service to parse view state loaded from local storage

import '../../src/main/webapp/lib/bootstrap-datepicker/js/bootstrap-datepicker.min.js'; // 1.5.1 but 1.7.1 available as npm module
// import '../../src/main/webapp/lib/angular-file-upload-12.2/ng-file-upload.min.js';
import 'ng-file-upload'; // provides 'Upload'
import '../../src/main/webapp/lib/angular-file-upload-master/dist/angular-file-upload.js'; // provides 'FileUploader'
import '../../src/main/webapp/lib/datejs/date.js';
//import '../../src/main/webapp/lib/angular-ui-bootstrap-2.5/dist/ui-bootstrap-tpls.js';
//import 'node_modules/angular-ui-bootstrap/dist/ui-bootstrap-tpls.js';
import 'angular-ui-bootstrap';
//"node_modules/angular-ui-bootstrap/dist/ui-bootstrap-tpls.js",
import '../../src/main/webapp/lib/angular-dialog-service-5.3.0/dialogs.js';
import '../../src/main/webapp/lib/bootstrap-custom.directives.js';
import '../../src/main/webapp/lib/ng-google-chart/ng-google-chart.js';
import '../../src/main/webapp/lib/ng-infinite-scroll-1.2.0/ng-infinite-scroll.js';
import '../../src/main/webapp/lib/angular-inview/angular-inview.js';
import '../../src/main/webapp/lib/i18n.module.js';
import '../../src/main/webapp/lib/localstorage.module.js';
//import '../../src/main/webapp/lib/angular-toggle-switch/angular-toggle-switch.min.js';
import 'angular-toggle-switch';
import '../../src/main/webapp/lib/angularjs-dropdown-multiselect/src/angularjs-dropdown-multiselect.js';
// import '../../src/main/webapp/lib/ng-intl-tel-input-1.3.2/intl-tel-input/build/js/utils.js';
// import '../../src/main/webapp/lib/ng-intl-tel-input-1.3.2/betsol-ng-intl-tel-input.js';
import 'betsol-ng-intl-tel-input';
import '../../src/main/webapp/lib/angular-ui-bootstrap/src/position/position.js';
import '../../src/main/webapp/lib/angular-ui-bootstrap-2.5/src/position/position.js';
import '../../src/main/webapp/lib/angular-scroll-dropdown-master/angular-scroll-dropdown.js';
import '../../src/main/webapp/lib/angular-dateparser/dist/angular-dateparser.js';
import '../../src/main/webapp/lib/angular-timepicker/src/angular-timepicker.js';
import '../../src/main/webapp/lib/angular-treeview-0.1.6/angular.treeview.js';
import '../../src/main/webapp/lib/ui-sortable-src0.13.4/src/sortable.js';
// import '../../src/main/webapp/lib/ng-onload/ng-onload.js';

// import '../../src/main/webapp/app/common/file-loader-interceptor.js';
import '../../src/main/webapp/app/common/analytics.js';
import '../../src/main/webapp/app/common/routes.js';
import '../../src/main/webapp/app/common/autoremind.app.js';
import '../../src/main/webapp/app/common/autoremind.services.js';
import '../../src/main/webapp/app/common/enhanced-http.js';
import '../../src/main/webapp/app/common/http-queue.js';
import '../../src/main/webapp/app/common/account.service.js';
import '../../src/main/webapp/app/common/userprofile.service.js';
import '../../src/main/webapp/app/common/user-settings.service.js';
import '../../src/main/webapp/app/common/autoremind.filters.js';
import '../../src/main/webapp/app/common/http-interceptor.js';
import '../../src/main/webapp/app/common/http-data-provider.js';
import '../../src/main/webapp/app/common/content-mocks.js';
import '../../src/main/webapp/app/common/print-service.js';
import '../../src/main/webapp/app/profile/profile.controllers.js';
import '../../src/main/webapp/app/common/autoremind.directives.js';
import '../../src/main/webapp/app/common/comment.directive.js';
import '../../src/main/webapp/app/common/contenteditable.directive.js';
import '../../src/main/webapp/app/common/image-list.directive.js';
import '../../src/main/webapp/app/common/ng-delay.directive.js';
import '../../src/main/webapp/app/common/integer.directive.js';
import '../../src/main/webapp/app/common/smart-float.directive.js';
import '../../src/main/webapp/app/common/show-focus.directive.js';
import '../../src/main/webapp/app/common/templates.services.js';
import '../../src/main/webapp/app/common/templates.ar2.services.js';
import '../../src/main/webapp/app/common/side.panel.directives.js';
import '../../src/main/webapp/app/common/printable-iframe.directive.js';
import '../../src/main/webapp/app/common/autoremind.controllers.js';
import '../../src/main/webapp/app/common/ng-click-copy.directive.js';
import '../../src/main/webapp/app/common/messages/compile.directive.js';
import '../../src/main/webapp/app/common/messages/image-upload.directive.js';
import '../../src/main/webapp/app/common/messages/upload-select-images.directive.js';
import '../../src/main/webapp/app/common/messages/preview-image.directive.js';
import '../../src/main/webapp/app/common/messages/browse-uploaded-images.directive.js';
import '../../src/main/webapp/app/common/messages/image-ui-no-cache.directive.js';
import '../../src/main/webapp/app/reminders/appointments.services.js';
import '../../src/main/webapp/app/communication/communications.audioservice.js';
import '../../src/main/webapp/app/communication/job.services.js';
import '../../src/main/webapp/app/communication/messages.services.js';
import '../../src/main/webapp/app/communication/communications.controllers.js';
import '../../src/main/webapp/app/communication/messaging-details.directive.js';
import '../../src/main/webapp/app/communication/communications.directives.js';
import '../../src/main/webapp/app/communication/forms/communications-message-editor.js';
import '../../src/main/webapp/app/communication/forms/communications-strategies.js';
import '../../src/main/webapp/app/communication/forms/target.directives.js';
import '../../src/main/webapp/app/communication/forms/communications-target-birthday.js';
import '../../src/main/webapp/app/communication/forms/communications-target-shortnotice.js';
import '../../src/main/webapp/app/communication/forms/communications-target-sales.js';
import '../../src/main/webapp/app/communication/forms/communications-target-recalls.js';
import '../../src/main/webapp/app/communication/forms/communications-target-missed.js';
import '../../src/main/webapp/app/communication/forms/communications-target-triggered.js';
import '../../src/main/webapp/app/communication/forms/communications-target-latePayment.js';
import '../../src/main/webapp/app/communication/forms/communications-target-latepaymentar3.js';
import '../../src/main/webapp/app/communication/forms/communications-filter-gender.js';
import '../../src/main/webapp/app/communication/forms/communications-filter-species.js';
import '../../src/main/webapp/app/communication/forms/communications-target-survey.js';
import '../../src/main/webapp/app/reports/reports.controllers.js';
import '../../src/main/webapp/app/reports/todo/todo.filters.js';
import '../../src/main/webapp/app/reports/reports.config.js';
import '../../src/main/webapp/app/reports/todo/todo.directive.js';
import '../../src/main/webapp/app/reports/todo/todo.services.js';
import '../../src/main/webapp/app/reports/todo/todo.modal.directive.js';
import '../../src/main/webapp/app/reports/unsubscribe/unsubscribe.directive.js';
import '../../src/main/webapp/app/reports/unsubscribe/unsubscribe.services.js';
import '../../src/main/webapp/app/reports/unsubscribe/unsubscribe.filters.js';
import '../../src/main/webapp/app/reports/communication/messages/messages.directive.js';
import '../../src/main/webapp/app/reports/communication/messages/messaging-details-report.directive.js';
import '../../src/main/webapp/app/reports/communication/messages/messages-overview.directive.js';
import '../../src/main/webapp/app/reports/communication/messages/messaging-report.directive.js';
import '../../src/main/webapp/app/reports/communication/survey/survey.directive.js';
import '../../src/main/webapp/app/reports/communication/survey/survey.service.js';
import '../../src/main/webapp/app/reports/communication/appointments-tables.directive.js';
import '../../src/main/webapp/app/reports/communication/recalls/recalls.directive.js';
import '../../src/main/webapp/app/reports/communication/missed/missed.directive.js';
import '../../src/main/webapp/app/reports/contacts/contacts.directive.js';
import '../../src/main/webapp/app/reports/contacts/contacts.service.js';
import '../../src/main/webapp/app/dev/test.controllers.js';
import '../../src/main/webapp/app/logs/logs.controllers.js';
import '../../src/main/webapp/app/csv/csvImport.service.js';
import '../../src/main/webapp/app/csv/csv.controllers.js';
import '../../src/main/webapp//app/reseller/reseller.services.js';
import '../../src/main/webapp/app/reseller/reseller.customers.controllers.js';
import '../../src/main/webapp/app/reseller/reseller.dashboard.controllers.js';
/* import '../../src/main/webapp/app/support/support.controllers.js'; */
import '../../src/main/webapp/app/dialog/dialogs.controllers.js';
import '../../src/main/webapp/app/dashboard/dashboard.directives.js';
import '../../src/main/webapp/app/dashboard/dashboard.services.js';
import '../../src/main/webapp/app/dashboard/dashboard.filters.js';
import '../../src/main/webapp/app/dashboard/dashboard.constants.js';
import '../../src/main/webapp/app/dashboard/dashboard.controllers.js';
import '../../src/main/webapp/app/dashboard/widgets/one-number.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/multi-number.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/reseller-paying-customers/reseller-paying-customers.js';
import '../../src/main/webapp/app/dashboard/widgets/reseller/reseller.js';
import '../../src/main/webapp/app/dashboard/widgets/reseller-in-trial/reseller-in-trial.js';
import '../../src/main/webapp/app/dashboard/widgets/messaging/messaging.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/recalls/recalls.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/missed/missed.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/birthday/birthday.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/support/support.directive.js';
import '../../src/main/webapp/app/dashboard/widgets/news/news.directive.js';
import '../../src/main/webapp/app/admin/users/users.controllers.js';
import '../../src/main/webapp/app/admin/users/admin-users-communication.js';
import '../../src/main/webapp/app/admin/users/admin-users-central-data.js';
import '../../src/main/webapp/app/admin/users/admin-user-billing-settings.js';
import '../../src/main/webapp/app/admin/messaging/messaging.controllers.js';
import '../../src/main/webapp/app/admin/voice/voice.controllers.js';
import '../../src/main/webapp/app/admin/chargify/chargify.controllers.js';
import '../../src/main/webapp/app/admin/chargify/chargify.service.js';
import '../../src/main/webapp/app/admin/chargify/admin-chargify-reconcile-subscriptions.js';
import '../../src/main/webapp/app/admin/chargify/admin-chargify-message-billing.js';
import '../../src/main/webapp/app/admin/queries/queries.services.js';
import '../../src/main/webapp/app/admin/queries/queries.controllers.js';
import '../../src/main/webapp/app/admin/satellites/satellites.controllers.js';
import '../../src/main/webapp/app/admin/satellites/satellites.services.js';
import '../../src/main/webapp/app/admin/satellites/satellite-setup/satellite-setup.directive.js';
import '../../src/main/webapp/app/admin/satellites/last-error.directive.js';
import '../../src/main/webapp/app/admin/satellites/satellite-errors.directive.js';
import '../../src/main/webapp/app/admin/templates/templates.controller.js';
import '../../src/main/webapp/app/admin/templates/admin-templates-all.js';
import '../../src/main/webapp/app/admin/templates/admin-templates-ar2-all.js';
import '../../src/main/webapp/app/admin/templates/admin-templates-prefabs.js';
import '../../src/main/webapp/app/admin/templates/admin-templates-users.js';
import '../../src/main/webapp/app/admin/templates/admin-templates-ar2-users.js';
import '../../src/main/webapp/app/admin/templates/admin-templates.change.dialog.controller.js';
import '../../src/main/webapp/app/admin/templates/admin-templates-content.js';
import '../../src/main/webapp/app/admin/templates/templates-upload.directive.js';
import '../../src/main/webapp/app/admin/templates/templates-ar2-upload.directive.js';
import '../../src/main/webapp/app/admin/templates/preview-edit-template-ar2.directive.js';
import '../../src/main/webapp/app/admin/templates/template-highlight.directive.js';
import '../../src/main/webapp/app/admin/templates/set-template-to-user.directive.js';
import '../../src/main/webapp/app/admin/templates/users-list-for-template.directive.js';
